import { Extra } from './trip.model';

export class SetTerminalsAction {
  static readonly type = '[TRIP] Set terminals';
  constructor(public inTerminal: number, public outTerminal: number) {}
}

export class SetCommonTerminalsAction {
  static readonly type = '[TRIP] Set common terminals';
  constructor(
    public commonInTerminal: number,
    public commonOutTerminal: number
  ) {}
}

export class SetPromoCodeAction {
  static readonly type = '[TRIP] Set promo code';
  constructor(
    public promoCode: string,
    public promoCodeRequestTimestamp: string
  ) {}
}

export class SetSourceModeAction {
  static readonly type = '[TRIP] Set source mode';
  constructor(public sourceMode: string) {}
}

export class SetAppModeAction {
  static readonly type = '[TRIP] Set app mode';
  constructor(public appMode: boolean) {}
}

export class SetClientAppModeAction {
  static readonly type = '[TRIP] Set client app mode';
  constructor(public clientAppMode: boolean) {}
}

export class SetAgentTokenAction {
  static readonly type = '[TRIP] Set agent token';
  constructor(public is_agent_token: boolean) {}
}

export class SetSelectedUpAction {
  static readonly type = '[TRIP] Set urban parking selected';
  constructor(public urbanParking: string) {}
}

export class SetIsMasBlauAction {
  static readonly type = '[TRIP] Set if is Mas Blau';
  constructor(public isMasBlau: boolean) {}
}

export class SetIsModifyReservationAction {
  static readonly type = '[TRIP] Set if is modifiying reservation';
  constructor(public isModify: boolean) {}
}

export class RemoveTerminalsAction {
  static readonly type = '[TRIP] Remove terminals';
}

export class SetPassengersAction {
  static readonly type = '[TRIP] Set passengers';
  constructor(public inPassengers: number, public outPassengers: number) {}
}

export class RemovePassengersAction {
  static readonly type = '[TRIP] Remove passengers';
}

export class SetFlightNumberAction {
  static readonly type = '[TRIP] Set flight number';
  constructor(public flightNumber: string) {}
}

export class RemoveFlightNumberAction {
  static readonly type = '[TRIP] Remove flight number';
}

export class SetShipAction {
  static readonly type = '[TRIP] Set ship';
  constructor(public ship: string) {}
}

export class RemoveShipAction {
  static readonly type = '[TRIP] Remove ship';
}

export class SetExtrasAction {
  static readonly type = '[TRIP] Set extras';
  constructor(public extras: Extra[]) {}
}

export class RemoveExtrasAction {
  static readonly type = '[TRIP] Remove extras';
}

export class RemoveTripAction {
  static readonly type = '[TRIP] Remove trip';
}
